//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";

// custom pages
import Table from "components/Table/Table";
import AuditAPI from "apis/audit/audit";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";

// material-ui
import Button from "@material-ui/core/Button";
import { CSVLink } from 'react-csv';
import * as moment from "moment";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import { toast } from "react-toastify";
import { exportHeaders } from "./export";

export default function AuditConfig() {
  const { state, dispatch } = useContext(context);
  const { getAuditConfig ,exports} = AuditAPI();
  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const [exportData, setExportData] = useState([]);

  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "Audit Config"] });
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset]);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      let res = await getAuditConfig(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleExport = async () => {
    let values = {};
    // let values = {};
    // let values;
    //   values = {
    //     offset: (offset - 1) * 30,
    //     limit: 30,
    //   };

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await exports(values);
    console.log(res,"ragav")
    if (res && res.data) {
        // setIsLoading(false);
        // setExportData(res.data);
        setExportData(res.data.map((d) => {
            return {
              ...d,
            create: d.create.toString(),
            delete :d.delete.toString(),
            reason:d.reason.toString(),
            update :d.update.toString()

            };
            
          })); 
          
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid xs={12} sm={12} lg={12}>
          <Button
            className={`${classes.createBtn} dash-1-filter-btn`}
            onClick={() => {
              history.push("/dashboard/create-audit-config");
            }}
          >
            Create
          </Button>
           <CSVLink
            id="csv"
            data={exportData}
              
             headers={exportHeaders}
         filename={
              `Audit-Log` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                
                document.getElementById("csv").click();
              }
            }}
          >
          Export
          </button>
         
        </Grid>
        
      </Grid>

      <Grid className={classes.tableDownInResponsive}>
        <Grid xs={12} sm={12} lg={12}>
          {res ? (
            <Table
              headings={[
                "Table Name",
                "Column Name",
                "Create",
                "Update",
                "Delete",
                "Reason",
                "",
              ]}
              data={
                data &&
                data.length > 0 &&
                data.map((d, i) => [
                  d?.table_name,
                  d?.column_name,
                  d?.create.toString(),
                  d?.update.toString(),
                  d?.delete.toString(),
                  d?.reason.toString(),
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push("/dashboard/view-audit-config", { data: d });
                    }}
                  >
                    <VisibilityIcon />
                  </div>,
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          ) : (
            <Loader Loading={true} top={"15%"} />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
